import {
  AssessmentTestContext,
  AssessmentTestContextType,
} from '../../../contexts/assessment-test';
import { NonCopyableMarkdown, NonPastableTextInput } from '../common';
import React from 'react';
import styled from 'styled-components';

const FollowUpWrapper = styled.div`
  margin-top: 72px;
`;

export default function FollowUp({
  section,
  stepId,
}: {
  section: AssessmentTestContextType['steps'][number]['sections'][number];
  stepId: string;
}) {
  const [, dispatch] = React.useContext(AssessmentTestContext);
  const onFollowUpAnswerChange = React.useCallback(
    (value: string) => {
      dispatch({
        type: 'CHANGE_FOLLOW_UP_ANSWER',
        payload: {
          stepId,
          sectionId: section.id,
          followUpAnswer: value,
        },
      });
    },
    [stepId, section.id, dispatch]
  );

  const hasFollowUp = section.hasFollowUp;
  if (!hasFollowUp) {
    return null;
  }

  return (
    <FollowUpWrapper>
      <NonCopyableMarkdown md={section.followUpContent} />
      <NonPastableTextInput
        placeholder={section?.followUpPlaceholder ?? ''}
        value={section.followUpAnswer}
        onChange={onFollowUpAnswerChange}
      />
    </FollowUpWrapper>
  );
}
